module.exports = __webpack_public_path__ + "img/Ca.b65e921c.png";